import React from "react";
import { graphql, useFragment } from "react-relay";
import { WorkspaceRoutineOccasionDescription_routine$key } from "./__generated__/WorkspaceRoutineOccasionDescription_routine.graphql";
import { RoutineOccasionDescriptionContent } from "../../../RoutineOccasion/RoutineOccasionScreen/RoutineOccasionDescriptionContent";
import { Box } from "arkh";

export function WorkspaceRoutineOccasionDescription(props: {
  routine: WorkspaceRoutineOccasionDescription_routine$key;
}) {
  const routine = useFragment(
    graphql`
      fragment WorkspaceRoutineOccasionDescription_routine on Routine {
        description
        descriptionImages {
          __typename
        }
        descriptionFiles {
          id
        }
        ...RoutineOccasionDescriptionContent_Routine
      }
    `,
    props.routine
  );

  const hasDescription =
    routine.description !== null && routine.description.length > 0;
  const hasMedia = routine.descriptionImages.length > 0;
  const hasFiles = routine.descriptionFiles.length > 0;

  if (!hasDescription && !hasMedia && !hasFiles) {
    return;
  }

  return (
    <Box spaceBottom="small" style={{ flex: 1 }}>
      <RoutineOccasionDescriptionContent routine={routine} hideOrg />
    </Box>
  );
}
